<template>
  <div>
    <el-card shadow="always">
      <el-page-header v-if="id === ''" @back="back" title :content="$t('adicionar-novo-carga')"></el-page-header>
      <el-page-header v-if="id !== ''" @back="back" title :content="$t('atualizar-carga')"></el-page-header>
    </el-card>
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
        <el-form-item :label="$t('cliente')" prop="code">
          <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="5">
            <CustomerList ref="customer" v-model="ruleForm.customer" :current="ruleForm.customer"
              v-on:selected="changed" />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('contrato')" prop="contract">
          <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="5">
            <el-select v-if="ruleForm.customer" v-model="ruleForm.contract" placeholder="Selecione  uma opção">
              <el-option v-for="row of contracts" :key="row.value" :label="row.text" :value="row.value"></el-option>
            </el-select>
            <ContractList v-else v-model="ruleForm.contract" :current="ruleForm.contract" />
          </el-col>
        </el-form-item>
        <el-form-item :label="$t('servico')" prop="service">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <ServicesList v-model="ruleForm.service" :current="ruleForm.service" />
          </el-col>
        </el-form-item>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item v-if="ruleForm.type === '1'" label="Sigla / Objeto Inicial / Objeto Final" prop="objectstarted">
              <el-input ref="acronym" v-model="ruleForm.acronnym" maxlength="2" style="width: 60px"></el-input>
              <el-input v-mask="'########'" ref="objectstarted" v-model="ruleForm.objectstarted" maxlength="8"  style="width: 120px"></el-input>&nbsp;à&nbsp;
              <el-input v-mask="'########'" ref="objectfinished" v-model="ruleForm.objectfinished" maxlength="8" style="width: 120px"></el-input>
              <el-input disabled value="BR" maxlength="2" style="width: 60px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item v-if="ruleForm.type === '2'" :label="$t('quantidade')" prop="quantity">
          <el-col :xs="12" :sm="6" :md="6" :lg="5" :xl="5">
            <el-input-number ref="quantity" :controls="false" :precision="0" :step="1" :max="10000" :min="0"
              v-model="ruleForm.quantity"></el-input-number>
          </el-col>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="warning" v-if="id === ''" autofocus @click="submitForm('ruleForm')">{{ $t("adicionar")
          }}</el-button>
          <el-button type="warning" v-if="id !== ''" autofocus @click="editForm('ruleForm')">{{ $t("atualizar")
          }}</el-button>
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { CustomerService } from "@/services/customers/customers.services";
import { LoadObjectService } from "@/services/load.object/loadobject.services";
import ContractList from "@/xpost/views/register/contract/ContractList";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ServicesList from "@/xpost/views/register/services/ServicesList";

export default {
  name: "LoadObjectsAdd",
  components: {
    CustomerList,
    ServicesList,
    ContractList,
  },
  watch: {
    "ruleForm.customer": function (v) {
      const vm = this;
      if (!vm.ruleForm.customer) {
        return true;
      }
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.get(vm.ruleForm.customer)
        .then((response) => {
          vm.contracts = [];

          for (const cardpost of response.cardpost) {
            const row = vm.contracts.find(
              (x) => x.value == cardpost.cardpost.contract.id
            );
            if (!row) {
              vm.contracts.push({
                value: cardpost.cardpost.contract.id,
                text: cardpost.cardpost.contract.contractid,
              });
            }
            if (cardpost.principal) {
              vm.ruleForm.contract = cardpost.cardpost.contract.id;
            }
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  data() {
    return {
      id: "",
      constracts: [],
      ruleForm: {
        customer: "",
        contract: "",
        service: "",
        quantity: 0,
        type: '1',
        acronnym: "",
        objectstarted: "",
        objectfinished: "",
      },
      rules: {
        objectstarted: [
          {
            required: true,
            message: "Objeto inicial é obrigatório!",
            trigger: "blur",
          },
        ],
        objectfinished: [
          {
            required: true,
            message: "Objeto final é obrigatório!",
            trigger: "blur",
          },
        ],
        service: [
          {
            required: true,
            message: "Serviço é obrigatório!",
            trigger: "blur",
          },
        ],
        contract: [
          {
            required: true,
            message: "Contrato é obrigatório!",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    changed() {
      const vm = this;
    },
    back() {
      var vm = this;
      vm.$router.replace({ name: "load.objects" });
    },
    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      LoadObjectService.get(vm.id)
        .then((response) => {
          vm.ruleForm.objectstarted = response.startTag;
          vm.ruleForm.objectfinished = response.endTag;
          vm.ruleForm.contract = response.contract ? response.contract.id : '';
          vm.ruleForm.client = response.customer ? response.customer.id : '';
          vm.ruleForm.service = response.service ? response.service.id : '';
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    submitForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          LoadObjectService.create(vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: "Carga de objetos adicionada com sucesso, aguarde alguns minutos para o processamento das etiquetas!",
              });
              //  vm.back();
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          LoadObjectService.update(vm.id, vm.ruleForm)
            .then((response) => {
              this.$message({
                type: "success",
                message: 'Carga de objetos atualizada com sucesso!',
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  mounted() {
    const vm = this;
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      vm.get();
    } else {
      vm.$refs.code.$el.children[0].focus();
    }
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}

form {
  margin-top: 20px;
}

@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
